import { ECode } from "~/_enums/ECode";
import { TApiConfig } from "~/_libs/fetch/fetchConfig";
import { fetchPostJson } from "../../_libs/fetch/fetchPostJson";
import { TUser } from "../../_types/TUser";

type TPostCommonUserOutputDto = {
  code: typeof ECode.Success;
  data: TUser;
};

type TPostCommonUserNotfoundOutputDto = {
  code: typeof ECode.NotFound;
  data: null;
};

/**
 * user 조회 api
 */
export const postCommonUser = (
  config: TApiConfig,
): Promise<TPostCommonUserOutputDto | TPostCommonUserNotfoundOutputDto> => {
  return fetchPostJson(`/v5draft/common-user`, { body: {} }, config);
};
